/**
 * @cji/shared — Modelo de dominio compartido.
 * Punto de entrada único: tipos, estados, roles, eventos y esquemas.
 */
export * from './roles.js';
export * from './estados.js';
export * from './eventos.js';
export * from './plazos.js';
export * from './accesos.js';
export * from './tipos.js';
export * from './esquemas.js';
/**
 * Colecciones de Firestore. Prefijadas con `trz_` para AISLAR el módulo dentro
 * del proyecto compartido `cji-portal-paneles` y no colisionar con las
 * colecciones del portal (usuarios, marcaciones, etc.).
 */
export const COLECCIONES = {
    usuarios: 'trz_usuarios',
    oficinas: 'trz_oficinas',
    expedientes: 'trz_expedientes',
    prestamos: 'trz_prestamos', // subcolección de expedientes
    otros: 'trz_otros', // subcolección de expedientes (otros documentos/soportes)
    eventos: 'trz_eventos',
};
/** Construye el radicado hijo de un préstamo: `P-{radicado}-{secuencia}`. */
export function construirRadicadoHijo(radicado, secuencia) {
    return `P-${radicado}-${secuencia}`;
}
//# sourceMappingURL=index.js.map